<template>
  <el-dialog :close-on-click-modal="false" title="开票信息" :visible.sync="isShow" width="700px" @closed='closed'>
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item label="商品名称:" prop="productName">
        <el-input v-model.trim="formData.productName" clearable></el-input>
      </el-form-item>
      <el-form-item label="简称:" prop="shortProductName">
        <el-input v-model.trim="formData.shortProductName" clearable></el-input>
      </el-form-item>
      <el-form-item label="税收分类名称:" prop="taxRateTypeId">
        <el-select v-model="formData.taxRateTypeId" @change="change" value-key="taxRateTypeId" placeholder="请选择">
          <el-option v-for="item in rateTypeList" :key="item.taxRateTypeId" :label="item.rateName" :value="item.taxRateTypeId">
          </el-option>
        </el-select>
        <el-form-item v-show="rateCode" label="税收分类编码:" style="display:inline-block;"> {{ rateCode }} </el-form-item>
      </el-form-item>
      <el-form-item label="税率:" prop="taxRate">
        <el-input v-model="formData.taxRate" type="number" clearable></el-input>
        <el-tooltip class="item" effect="light" content="设置为0则为免税" placement="right">
          <i class="el-icon-warning" style="cursor: pointer;"></i>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { taxRateTypeListAll, taxRateAdd } from '@/api/finance'
export default {
  data () {
    return {
      loading: false,
      isShow: false,
      formData: {
        productName: '',
        shortProductName: '',
        spec: '',
        taxRate: '',
        taxRateTypeId: '',
        unit: ''
      },
      rateCode: '',
      rateTypeList: [],
      rules: {
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        shortProductName: [
          { required: true, message: '请输入简称', trigger: 'blur' }
        ],
        taxRateTypeId: [
          { required: true, message: '请选择税收分类', trigger: 'change' }
        ],
        taxRate: [
          { required: true, message: '请输入税率', trigger: 'blur' }
        ]
      }

    }
  },
  methods: {
    show () {
      this.isShow = true
      this.getAllRateList()
    },
    hide (emit) {
      emit && (this.$emit('success'))
      this.isShow = false
    },
    closed () {
      this.$nextTick(_ => {
        this.rateCode = ''
        this.$refs.form.resetFields()
      })
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.loading = true
        taxRateAdd(this.formData)
          .then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
              this.hide(true)
              this.loading = false
            }
          }).finally((fin) => {
            this.hide(true)
            this.loading = false
          })
      })
    },
    getAllRateList () {
      taxRateTypeListAll()
        .then(res => {
          if (res.data.success) {
            this.rateTypeList = res.data.data
          }
        })
    },
    change (id) {
      this.rateCode = this.rateTypeList.find(item => {
        return item.taxRateTypeId === id
      }).rateCode
    }
  }
}
</script>

<style>
</style>
